import { useAxios } from "./api";
const basePath = "/api/v1/accounts";
export const endpoint = {
  getAccountById: { path: `${basePath}/`, method: "GET" },
  createAccount: { path: `${basePath}`, method: "POST" },
  putAccount: { path: `${basePath}`, method: "PUT" },
  patchAccountAccectPolicy: { path: `${basePath}`, method: "PATCH" },
  deleteAccount: { path: `${basePath}/{{identifier}}`, method: "DELETE" },
  restoreAccount: {
    path: `${basePath}/{{identifier}}/restore`,
    method: "PATCH",
  },
};

export const useQueryAccountById = () => {
  const [state, fetchFn] = useAxios(
    {
      method: endpoint.getAccountById.method,
    },
    { manual: true }
  );
  return [
    state,
    (id) => {
      return fetchFn({
        url: endpoint.getAccountById.path.concat(id),
      });
    },
  ];
};

export const useUpdateAccount = () => {
  let [state, fetchFn] = useAxios(
    {
      method: endpoint.putAccount.method,
    },
    { manual: true }
  );
  return [
    state,
    (id, data) =>
      fetchFn({
        url: `${endpoint.putAccount.path}/${id}`,
        data,
      }),
  ];
};
export const useAccountAcceptPolicy = () => {
  let data = {
    is_read_policy: true,
  };
  let [state, fetchFn] = useAxios(
    {
      method: endpoint.patchAccountAccectPolicy.method,
    },
    { manual: true }
  );
  return [
    state,
    (id) =>
      fetchFn({
        url: `${endpoint.patchAccountAccectPolicy.path}/${id}/update_is_read_policy`,
        data,
      }),
  ];
};
export const useDeleteAccount = (identifier) => {
  return useAxios({
    url: endpoint.deleteAccount.path.replace("{{identifier}}", identifier),
    method: endpoint.deleteAccount.method,
  });
};
export const useRestoreAccount = (identifier) => {
  return useAxios({
    url: endpoint.restoreAccount.path.replace("{{identifier}}", identifier),
    method: endpoint.restoreAccount.method,
  });
};
